import React, { useContext } from "react";
import Typography from "../../../Typography";
import { ToastContext } from "../../ToastProvider";
import CloseIconButton from "../CloseIconButton";
import useToast from "./hooks/useToast";
import { BaseContent, BaseToast } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Toast(_ref) {
  var title = _ref.title,
    message = _ref.message,
    hideIcon = _ref.hideIcon,
    onClose = _ref.onClose;
  var type = useContext(ToastContext);
  var _useToast = useToast(type),
    IconComponent = _useToast.IconComponent;
  return /*#__PURE__*/_jsxs(BaseToast, {
    type: type,
    children: [!hideIcon && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(IconComponent, {
        size: "1rem",
        className: "icon"
      })
    }), /*#__PURE__*/_jsxs(BaseContent, {
      children: [title && /*#__PURE__*/_jsx(Typography, {
        variant: "display200",
        children: title
      }), message && /*#__PURE__*/_jsx(Typography, {
        children: message
      })]
    }), /*#__PURE__*/_jsx(CloseIconButton, {
      onClose: onClose
    })]
  });
}
export default Toast;